import * as React from "react";
const SvgEmailListSplitView = (props) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 14, viewBox: "0 0 18 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 14V12H18V14H0ZM0 10V8H18V10H0ZM0 6V4H18V6H0ZM0 2V0H18V2H0Z", fill: "#8A939A" }));
export default SvgEmailListSplitView;
